import { Form, FormInstance, Radio, Space } from 'antd'
import { t } from 'i18next'
import { searchReviewSavingTypes } from '../../../../../constants/constants'

export interface CreateSearchReviewSetupStepProps {
  form: FormInstance
}

const CreateSearchReviewSetupStep = ({
  form,
}: CreateSearchReviewSetupStepProps) => {
  return (
    <Form.Item
      label={t('createSearchReviewModal.steps.setupStep.subHeader')}
      required
      rules={[{ required: true, message: t('errorMessage.isRequired') || '' }]}
      name="savingType"
    >
      <Radio.Group>
        <Space direction="vertical">
          <Radio value={searchReviewSavingTypes.EXISTING}>
            {t(
              'createSearchReviewModal.steps.setupStep.existingReviewLabel'
            )}
          </Radio>
          <Radio value={searchReviewSavingTypes.NEW}>
            {t('createSearchReviewModal.steps.setupStep.newReviewLabel')}
          </Radio>
        </Space>
      </Radio.Group>
    </Form.Item>
  )
}

export default CreateSearchReviewSetupStep
